import { Box, styledComponent } from '@hermes/web-components'

export const DefaultContainer = styledComponent('section')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  width: '100%',
  padding: '74px 16px 22px 16px',

  '@media (max-width: 1110px)': {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 120px 12px 120px'
  },

  '@media (max-width: 768px)': {
    padding: '0px 16px 12px 16px'
  }
})

export const Variant2Container = styledComponent(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridRowGap: '54px',
  gridColumnGap: '32px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(3, 1fr)'
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)'
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(1, 1fr)'
  }
}))

export const TitleContainer = styledComponent('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'center'
})

export const Title = styledComponent('h2')`
  font-size: 30px;
  font-weight: 700;
  background: linear-gradient(0deg, #2B59E0, #2B59E0),
              linear-gradient(90deg, rgba(17, 41, 113, 0.5) 0%, rgba(43, 89, 224, 0.5) 99.99%, rgba(43, 89, 224, 0.5) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  margin: 0;
  -webkit-text-fill-color: transparent;
  @media (max-width: 768px) {
    text-align: center;
    letter-spacing: -1px;
  }
`

export const SeeButton = styledComponent('a')`
  padding: 8px 24px;
  border-radius: 20px;
  border: 1px solid #1A3586;
  height: 40px;
  width: fit-content;
  background-color: transparent;
  color: #1A3586;
  font-weight: 500;
  font-size: 15px;
  text-decoration: none;
  line-height: 22px;
  box-shadow: 0px 1px 2px 0px #0000000A;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
  background-color: #EAEEFC;
  }
  `

export const RoundCardContainer = styledComponent('div')`
  display: flex;
  gap: 24px;
  justify-content: center;
  @media (max-width: 1110px) {
    flex-wrap: wrap;
    max-width: 700px;
  } 
  @media (max-width: 768px) {
    flex-wrap: wrap;
    width: 100%;
    max-width: 578px;
  }
  `
